<template>
  <div class="news" @click="showSort = false">
    <innerBanner :banner="$t('news.banner')" />
    <div class="wp2 news-wrap">
      <div class="sort">
        <div class="show" @click.stop="showSort = !showSort">
          <i></i>
          <span>{{ $t('news.sort.txt1') }}</span>
        </div>
        <ul v-if="showSort" @click.stop>
          <li>
            <label>
              <input
                type="radio"
                name="sort"
                v-model="order"
                value="desc"
                @change="handleSortChange"
              />
              <span>{{ $t('news.sort.txt2') }}</span>
            </label>
          </li>
          <li>
            <label>
              <input
                type="radio"
                name="sort"
                v-model="order"
                value="asc"
                @change="handleSortChange"
              />
              <span>{{ $t('news.sort.txt3') }}</span>
            </label>
          </li>
        </ul>
      </div>
      <div class="news-list2" v-loading="isLoading">
        <newsItem v-for="(item, index) in newsList" :key="index" :item="item" />
      </div>
      <!-- <pagination /> -->
      <div class="page">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          @current-change="pageChange"
          :page-size="pageSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import innerBanner from '@/components/innerBanner'
import newsItem from '@/components/newsItem'
import pagination from '@/components/pagination'
export default {
  name: 'news',
  components: {
    innerBanner,
    newsItem,
    pagination
  },
  data() {
    return {
      offsetTopNews: 0,
      isLoading: false,
      currPage: 0,
      pageSize: 8,
      total: 0,
      newsList: [],
      showSort: false,
      order: 'desc'
    }
  },
  activated() {
    window.scrollTo(0, this.offsetTopNews || 0)
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'newsDetail') this.offsetTopNews = document.documentElement.scrollTop
    else this.offsetTopNews = 0
    next()
  },
  created() {
    this.getNews()
  },
  methods: {
    async getNews() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          sort: ['priority:desc', `date:${this.order}`],
          pagination: {
            page: this.currPage,
            pageSize: this.pageSize
          },
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      this.isLoading = true
      const { data } = await this.$http.get(`${this.$strapiUrl}/news?${queryInfo}`)
      this.total = data.meta.pagination.total
      const res = data.data
      this.newsList = res.map((item) => ({
        id: item.id,
        img: item.attributes.pic.data ? item.attributes.pic.data.attributes.url : '',
        title: item.attributes.title,
        date: item.attributes.date
      }))
      this.isLoading = false
    },
    pageChange(page) {
      this.currPage = page
      this.getNews()
    },
    handleSortChange() {
      this.showSort = false
      this.getNews()
    }
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.getNews()
      this.enFontFamily =
        newValue === 'zh'
          ? {}
          : {
              fontFamily: 'Arial'
            }
      this.enBold =
        newValue === 'zh'
          ? {}
          : {
              fontWeight: 'bold'
            }
    }
  }
}
</script>

<style scoped lang="scss">
//news
.news {
  .news-wrap {
    padding: 66px 0;
  }
  .sort {
    margin-bottom: 42px;
    position: relative;
    padding-left: 15px;
    .show {
      display: inline-block;
      cursor: pointer;
      i {
        display: inline-block;
        vertical-align: middle;
        width: 32px;
        height: 32px;
        background: url('~@/assets/images/sort.png') no-repeat center center / contain;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        @extend .sub1-18px;
      }
    }
    ul {
      position: absolute;
      z-index: 20;
      top: 100%;
      left: 0;
      background: $white2;
      border-radius: 10px;
      padding: 24px 18px;
      width: 240px;
      li {
        height: 24px;
        display: flex;
        align-items: center;
      }
      li + li {
        margin-top: 24px;
      }
      label {
        display: block;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        input {
          position: absolute;
          left: -99999px;
        }
        span {
          @extend .regular-16px;
          display: flex;
          align-items: center;
          padding-left: 36px;
          position: relative;
          .num {
            opacity: 0.5;
            margin-left: 8px;
          }
        }
        span:after {
          content: '';
          width: 20px;
          height: 20px;
          background: #ffffff;
          border: 1px solid #dddbcb;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 50%;
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          transform: translateY(-50%);
        }
        input:checked + span:after {
          border-color: $black;
          background: url('~@/assets/images/checked.png') no-repeat center center / contain;
        }
      }
      label.disabled {
        pointer-events: none;
        span {
          color: rgba(42, 39, 40, 0.5);
        }
        span:after {
          border-color: rgba(42, 39, 40, 0.5);
        }
      }
    }
  }
}
.news-list2 {
  display: flex;
  flex-wrap: wrap;
  .news-item {
    flex: 0 0 calc(50% - 20px);
    margin: 0 10px 40px;
  }
}
.page {
  text-align: center;
}
@media only screen and (max-width: 1199px) {
  .news .news-wrap {
    padding: 66px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .news .news-wrap {
    padding: 40px 20px;
  }
  .news .sort .show span {
    font-size: 14px;
  }
  .news-list2 {
    display: block;
    .news-item {
      width: 100%;
      margin: 0 0 40px;
    }
  }
  .news .sort ul {
    width: 182px;
  }
  .news .sort {
    margin-bottom: 20px;
  }
}
</style>
